import useMountEffect from '@restart/hooks/useMountEffect';
import { useDispatch } from 'react-redux';

import actions from '@/actions';
import API from '@/helpers/API';

const matchesFilters = (robot, filters) => {
  return filters.every(({ field, value }) => {
    const fieldValue = field.split('.').reduce((object, key) => object[key], robot);
    return value === fieldValue;
  });
};

const useLoadRobots = (filters = [], callback) => {
  const dispatch = useDispatch();

  useMountEffect(() => {
    // API: 로봇내역 조회
    API.get('/robots').then(({ success, data }) => {
      if (success) {
        const filtered = data.filter((robot) => matchesFilters(robot, filters));
        dispatch(actions.robots.load(filtered));

        // callback 정의 시 실행
        callback?.(filtered);
      }
    });
  });
};

export default useLoadRobots;
